export default class BrowserService {
    static getCurrentBrowser() {
        const userAgent = navigator.userAgent.toLowerCase();
        const browserChecks = {
            opera: userAgent.includes("opera") || userAgent.includes("opr"),
            firefox: userAgent.includes("firefox"),
            safari: /^((?!chrome|android).)*safari/i.test(userAgent),
            edge: userAgent.includes("edg"),
            chrome: userAgent.includes("chrome") && !userAgent.includes("edg"),
            ie: userAgent.includes("msie") || userAgent.includes("trident"),
        };

        for (const [browser, isMatch] of Object.entries(browserChecks)) {
            if (isMatch) {
                return browser;
            }
        }
        return "unknown";
    }
}
